const topicsRouter = [{
		path: '/topics/corporate-training',
		name: 'topics-corporate-training',
		component: _ => import("@/pages/topics/corporate-training.vue"),
		meta: {
			title: '企业内训'
		},
	},
	{
		path: "/topics/enterprise-zone",
		name: "topics-enterprise-zone",
		component: _ => import("@/pages/topics/enterprise-zone.vue"),
		meta: {
			// 页面标题title
			title: '企业专区'
		}
	},
	{
		path: "/topics/member",
		name: "topics-member",
		component: _ => import("@/pages/topics/member.vue"),
		meta: {
			// 页面标题title
			title: '会员VIP'
		}
	},
]
export default topicsRouter
